module.exports = __webpack_public_path__ + "static/media/private-space-video.faff57db.mp4";